import React, { Fragment, useState } from 'react';
import { translate } from '../Services/translation';
import { INCREASE_QTY, DECREASE_QTY } from '../bevegoConstants';


const ProductQuantity = ({
    quantityFieldId,
    multipleValue,
    inStockQuantity,
    unitOfMeasurement,
    decimalAmount
}) => {
    const [showWarning, setShowWarning] = useState(false);

    const toggleWarning = (show) => {
        setShowWarning(show || !showWarning);
    }

    const checkMultiple = (multipleQty, currentQty, decimalAmount, inStockQuantity, updateType) => {
        if (multipleQty !== undefined) {
            if (inStockQuantity < multipleQty && inStockQuantity >= currentQty) {
                return currentQty + ' ' + unitOfMeasurement;
            }
            if (multipleQty > 0) {
                decimalAmount = Number(decimalAmount);

                const quantityAsDecimal = parseFloat(currentQty);
                const quantityAsString = currentQty.toString();

                const precision = quantityAsString.indexOf('.') >= 0
                    ? quantityAsString.indexOf('.') + decimalAmount + 1
                    : quantityAsString.length;
                currentQty = quantityAsDecimal.toPrecision(precision);

                multipleQty = parseFloat(Number(multipleQty));
                if (multipleQty.toString().indexOf('.') >= 0) {
                    multipleQty = multipleQty.toFixed(decimalAmount);
                }

                const multiple = multipleQty;
                const modulus = (currentQty % multiple).toFixed(decimalAmount + 1);

                if (Number(modulus) !== 0) {

                    let diff = currentQty / multiple;
                    if (updateType === DECREASE_QTY) {
                        diff = Math.floor(diff);
                    }
                    else if (updateType === INCREASE_QTY) {
                        diff = Math.ceil(diff);
                    } else {
                        toggleWarning(true);
                        diff = Math.ceil(diff);
                    }

                    let result = multiple * diff;
                    if (result.toString().indexOf('.') >= 0) {
                        result = result.toFixed(decimalAmount);
                    }
                    return result + ' ' + unitOfMeasurement;
                }

                return Number(currentQty) < Number(multipleQty)
                    ? multipleQty + ' ' + unitOfMeasurement
                    : Number(currentQty).toFixed(decimalAmount) + ' ' + unitOfMeasurement;
            } else {
                return currentQty + ' ' + unitOfMeasurement;
            }
        } else {
            return 0 + ' ' + unitOfMeasurement;
        }
    }

    const updateValue = (quantityFieldId, multipleValue, inStockQuantity, updateType) => {
        const el = document.getElementById(quantityFieldId);
        multipleValue = parseFloat(multipleValue);
        inStockQuantity = parseInt(inStockQuantity);
        if (el) {
            let amountValue = el.value.split(' ')[0];
            let currentQty = parseFloat(amountValue);

            if (updateType === INCREASE_QTY) {
                currentQty++;
            } else if (updateType === DECREASE_QTY && currentQty > 0) {
                currentQty--;
            }
            currentQty = isNaN(currentQty) || currentQty < multipleValue ? multipleValue : currentQty;

            if (inStockQuantity < multipleValue && inStockQuantity >= amountValue && updateType == null) {
                currentQty = amountValue;
            }
            else if (currentQty >= multipleValue) {
                el.value = currentQty + ' ' + unitOfMeasurement;
            }
            const calculatedAmount = checkMultiple(multipleValue, currentQty, decimalAmount, inStockQuantity, updateType);
            el.value = calculatedAmount;
        }
    }

    return (
        <Fragment>
            <div className="product__buy-quantity-wrapper">
                <div className="product__buy-quantity-decrease" onClick={() => updateValue(quantityFieldId, multipleValue, inStockQuantity, DECREASE_QTY)}>
                    <i className="fas fa-minus"></i>
                </div>
                <div className="product__buy-quantity-input-container">
                    <input id={quantityFieldId}
                        type="text"
                        data-buy-quantity-input
                        defaultValue={`${multipleValue} ${unitOfMeasurement}`}
                        min="1"
                        max="999"
                        className="product__buy-quantity form__input"
                        aria-label={translate('common.productquantity.label')}
                        onBlur={() => updateValue(quantityFieldId, multipleValue, inStockQuantity)} />
                </div>
                <div className="product__buy-quantity-increase" onClick={() => updateValue(quantityFieldId, multipleValue, inStockQuantity, INCREASE_QTY)}>
                    <i className="fas fa-plus"></i>
                </div>
            </div>
        </Fragment>
    );
};
export default ProductQuantity;